import React from 'react';
// import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { Link as MUILink } from '@mui/material';
import { makeStyles } from '@mui/styles';

// TODO Rethink this StyledLink component

const StyledLink = ({ children, to, gatsbyLink, ...rest }) => {
  const classes = {
    gatsbyLink: {
      fontSize: (theme) => theme.typography.fontSize,
      textDecoration: 'none',
      color: (theme) => theme.palette.primary.main,
      '&:hover': {
        color: (theme) => theme.palette.action.active,
      },
    },
  };
  return gatsbyLink ? (
    <MUILink className={classes.gatsbyLink} to={to} {...rest}>
      {children}
    </MUILink>
  ) : (
    <MUILink underline="none" href={to} sx={classes.gatsbyLink}>
      {children}
    </MUILink>
  );
};

StyledLink.defaultProps = {
  gatsbyLink: false,
};

StyledLink.propTypes = {
  children: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  gatsbyLink: PropTypes.bool,
};

export default StyledLink;
